import React from "react";
import TestimonialForm from "./TestimonialForm";

const Footer = () => {
  return (
    <>
      <footer
      className="container-fluid text-white"
      style={{ backgroundColor: "#A71717", padding: "40px 0" }}
    >
      <div className="container">
        <div className="row g-4 align-items-start">
          {/* Contact Info */}
          <div className="col-12 col-sm-6 col-md-3 small">
            <h6 className="fw-bold text-white mb-3">Contact Info</h6>
            <p className="mb-2">
              <i className="fa fa-map-marker-alt  me-2"></i> ICT Park, Addis Ababa, Ethiopia
            </p>
            <p className="mb-2">
              <i className="fas fa-phone me-2"></i> +251 913 897665
            </p>
            <p className="mb-2">
              <i className="fas fa-phone me-2"></i> +251 909 434470
            </p>
            <p className="mb-2">
              <i className="fas fa-envelope me-2"></i> info@yodbusiness.com
            </p>
            <p className="mb-3">
              <i className="fas fa-globe me-2"></i> www.yodbusiness.com
            </p>
            <div className="d-flex">
              <i className="fas fa-share fa-sm me-2 mt-1"></i>
              <div>
                {["facebook-f", "twitter", "instagram", "linkedin-in"].map((icon, i) => (
                  <a
                    key={i}
                    href="#"
                    className="text-white me-2"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <i className={`fab fa-${icon}`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Opening Time */}
          <div className="col-12 col-sm-6 col-md-3 small">
            <h6 className="fw-bold text-white mb-3">Opening Time</h6>
            <p className="mb-0">24/7 Every Day (Monday–Monday)</p>
          </div>

          {/* Our Pages */}
          <div className="col-12 col-sm-6 col-md-3 small">
            <h6 className="fw-bold text-white mb-3">Our Pages</h6>
            {["Home", "About Us", "Clients", "Events", "Service"].map((page, i) => (
              <p key={i} className="mb-2">
                <i className="fas fa-angle-right me-2"></i> {page}
              </p>
            ))}
          </div>

          {/* Share Your Testimonial */}
          <div className="col-md-3 small">
            <h6 className="fw-bold text-white mb-3">Share Your Testimonial</h6>
            <TestimonialForm />
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
